import { Link } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-surface-2">
      {/* Header */}
      <div className="bg-surface shadow-sm">
        <div className="max-w-4xl mx-auto px-4 py-6">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-accent hover:underline mb-4"
          >
            <ArrowLeft className="w-4 h-4" />
            Volver
          </Link>
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-accent rounded-full flex items-center justify-center">
              <Shield className="w-6 h-6 text-accent" />
            </div>
            <h1 className="text-2xl sm:text-3xl font-bold text-ink">
              Política de Privacidad
            </h1>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="bg-surface rounded-xl shadow-sm p-6 sm:p-8 space-y-6">
          <p className="text-sm text-ink-muted">
            Última actualización: 1 de diciembre de 2025
          </p>

          {/* Section 1 */}
          <section>
            <h2 className="text-xl font-semibold text-ink mb-3">
              1. Información al Usuario
            </h2>
            <div className="text-ink-muted space-y-3">
              <p><strong>¿Quién es el responsable del tratamiento de tus datos personales?</strong></p>
              <p>
                Monkey Barber Club es el RESPONSABLE del tratamiento de los datos personales del USUARIO
                y le informa de que estos datos serán tratados de conformidad con lo dispuesto en el
                Reglamento (UE) 2016/679, de 27 de abril (GDPR), y la Ley Orgánica 3/2018, de 5 de
                diciembre (LOPDGDD).
              </p>
            </div>
          </section>

          {/* Section 2 */}
          <section>
            <h2 className="text-xl font-semibold text-ink mb-3">
              ¿Para qué tratamos tus datos personales y por qué lo hacemos?
            </h2>
            <div className="text-ink-muted space-y-3">
              <p>
                Según el formulario donde hayamos obtenido sus datos personales, los trataremos de
                manera confidencial para alcanzar los siguientes fines:
              </p>
              <div>
                <p><strong>En el formulario de Registro de usuario:</strong></p>
                <ul className="list-disc list-inside mt-2 space-y-1">
                  <li>Gestionar la cuenta del usuario para proporcionarle un acceso personalizado a la aplicación y a los servicios interactivos que ofrece. (por el consentimiento del interesado, 6.1.a GDPR)</li>
                  <li>Gestionar las reservas y turnos de cola virtual. (por el consentimiento del interesado, 6.1.a GDPR)</li>
                  <li>Gestionar el programa de fidelización y puntos. (por el consentimiento del interesado, 6.1.a GDPR)</li>
                  <li>Enviar notificaciones sobre el estado de sus turnos y citas. (por el interés legítimo del responsable, art. 6.1.f GDPR)</li>
                </ul>
              </div>
              <div>
                <p><strong>En el formulario de Contacto:</strong></p>
                <ul className="list-disc list-inside mt-2 space-y-1">
                  <li>Dar respuesta a las consultas o cualquier tipo de petición que sea realizada por el usuario a través de cualquiera de las formas de contacto que se ponen a su disposición. (por el interés legítimo del responsable, art. 6.1.f GDPR)</li>
                  <li>Realizar análisis estadísticos y estudios de mercado. (por el interés legítimo del responsable, art. 6.1.f GDPR)</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Section 3 */}
          <section>
            <h2 className="text-xl font-semibold text-ink mb-3">
              ¿Durante cuánto tiempo guardaremos tus datos personales?
            </h2>
            <p className="text-ink-muted">
              Se conservarán durante no más tiempo del necesario para mantener el fin del tratamiento
              o existan prescripciones legales que dictaminen su custodia y cuando ya no sea necesario
              para ello, se suprimirán con medidas de seguridad adecuadas para garantizar la
              anonimización de los datos o la destrucción total de los mismos.
            </p>
          </section>

          {/* Section 4 */}
          <section>
            <h2 className="text-xl font-semibold text-ink mb-3">
              ¿A quién facilitamos tus datos personales?
            </h2>
            <p className="text-ink-muted">
              No está prevista ninguna comunicación de datos personales a terceros salvo, si fuese
              necesario para el desarrollo y ejecución de las finalidades del tratamiento, a nuestros
              proveedores de servicios relacionados con comunicaciones, con los cuales el RESPONSABLE
              tiene suscritos los contratos de confidencialidad y de encargado de tratamiento exigidos
              por la normativa vigente de privacidad.
            </p>
          </section>

          {/* Section 5 */}
          <section>
            <h2 className="text-xl font-semibold text-ink mb-3">
              ¿Cuáles son tus derechos?
            </h2>
            <div className="text-ink-muted space-y-3">
              <p>Los derechos que asisten al USUARIO son:</p>
              <ul className="list-disc list-inside space-y-1">
                <li>Derecho a retirar el consentimiento en cualquier momento.</li>
                <li>Derecho de acceso, rectificación, portabilidad y supresión de sus datos, y de limitación u oposición a su tratamiento.</li>
                <li>Derecho a presentar una reclamación ante la autoridad de control (www.aepd.es) si considera que el tratamiento no se ajusta a la normativa vigente.</li>
              </ul>
              <p><strong>Datos de contacto para ejercer sus derechos:</strong></p>
              <p>
                Monkey Barber Club<br />
                E-mail: info@monkeybarber.club<br />
                Datos de contacto del delegado de protección de datos: BM GESTDATA, S.L - ONTIDATA,
                Avda. Albaida, 19, 46870 Ontinyent - dpd@ontidata.es
              </p>
            </div>
          </section>

          {/* Section 6 */}
          <section>
            <h2 className="text-xl font-semibold text-ink mb-3">
              2. Carácter Obligatorio o Facultativo de la Información Facilitada por el Usuario
            </h2>
            <div className="text-ink-muted space-y-3">
              <p>
                Los USUARIOS, mediante la marcación de las casillas correspondientes y la entrada de
                datos en los campos, marcados con un asterisco (*) en el formulario de contacto o
                presentados en formularios de registro, aceptan expresamente y de forma libre e
                inequívoca, que sus datos son necesarios para atender su petición, por parte del
                prestador, siendo voluntaria la inclusión de datos en los campos restantes.
              </p>
              <p>
                El USUARIO garantiza que los datos personales facilitados al RESPONSABLE son veraces
                y se hace responsable de comunicar cualquier modificación de los mismos.
              </p>
              <p>
                El RESPONSABLE informa de que todos los datos solicitados a través del sitio web son
                obligatorios, ya que son necesarios para la prestación de un servicio óptimo al
                USUARIO. En caso de que no se faciliten todos los datos, no se garantiza que la
                información y servicios facilitados sean completamente ajustados a sus necesidades.
              </p>
            </div>
          </section>

          {/* Section 7 */}
          <section>
            <h2 className="text-xl font-semibold text-ink mb-3">
              3. Medidas de Seguridad
            </h2>
            <div className="text-ink-muted space-y-3">
              <p>
                De conformidad con lo dispuesto en las normativas vigentes en protección de datos
                personales, el RESPONSABLE está cumpliendo con todas las disposiciones de las
                normativas GDPR y LOPDGDD para el tratamiento de los datos personales de su
                responsabilidad, y manifiestamente con los principios descritos en el artículo 5
                del GDPR, por los cuales son tratados de manera lícita, leal y transparente en
                relación con el interesado y adecuados, pertinentes y limitados a lo necesario en
                relación con los fines para los que son tratados.
              </p>
              <p>
                El RESPONSABLE garantiza que ha implementado políticas técnicas y organizativas
                apropiadas para aplicar las medidas de seguridad que establecen el GDPR y la LOPDGDD
                con el fin de proteger los derechos y libertades de los USUARIOS y les ha comunicado
                la información adecuada para que puedan ejercerlos.
              </p>
              <p>
                Para más información sobre las garantías de privacidad, puedes dirigirte al
                RESPONSABLE a través de:<br />
                Monkey Barber Club<br />
                E-mail: info@monkeybarber.club<br />
                Datos de contacto del delegado de protección de datos: BM GESTDATA, S.L - ONTIDATA,
                Avda. Albaida, 19, 46870 Ontinyent - dpd@ontidata.es
              </p>
            </div>
          </section>

          {/* Links to other policies */}
          <div className="border-t border-hairline pt-6 mt-8">
            <h3 className="text-sm font-medium text-ink mb-3">
              Políticas relacionadas
            </h3>
            <div className="flex flex-wrap gap-4">
              <Link
                to="/cookies-policy"
                className="text-accent hover:underline text-sm"
              >
                Política de Cookies
              </Link>
              <Link
                to="/terms-of-service"
                className="text-accent hover:underline text-sm"
              >
                Términos de Servicio
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
